import React from 'react';
// @ts-ignore
import { Grafico } from '../../Components/index.tsx';
// @ts-ignore
import { useTotalVendasPorLoja } from '../../../hooks/useTotalVendasPorLoja.tsx';

export const TotalVendasPorLoja: React.FC = () => {
  const { grafico, data, isLoading } = useTotalVendasPorLoja();

  return <Grafico title="Total de vendas por Loja" grafico={grafico} isLoading={isLoading} data={data} />;
};
